import React, {Component} from 'react';
import { connect } from 'react-redux';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('TRANSMISSION_STATUS_VISIBILITY_SELECTOR', LOG_LEVELS.DEBUG);

class TransmissionStatusVisibilitySelector extends Component {

    constructor(props) {
        super(props);
        this.checkboxChangeHandlerFactory = this.checkboxChangeHandlerFactory.bind(this);
    }

    checkboxChangeHandlerFactory(fieldName) {
      return (event) => {
        log.debug('checkboxChangeHandlerFactory(%s): oldValue: %s, newValue: %s  ', this.props[fieldName], event.target.checked, event);
        let selection = {};
        selection[fieldName] = event.target.checked ? 'true' : 'false';
        this.props.selectionHandler(selection);
      };
    }

    render() {
        log.debug("render(): ", this.props);
        return (
            <fieldset>
              <legend><LanguageStringResolver string='transmissionStatusFilterPanel_Status'/></legend>
              <span className="clear"></span>
              <input type="checkbox" 
                checked={typeof this.props.showSuccessful === 'string' && this.props.showSuccessful.toLowerCase() === 'true'} 
                onChange={this.checkboxChangeHandlerFactory('showSuccessful')}/>
              <label className="checkbox"><LanguageStringResolver string='transmissionStatusFilterPanel_Successful'/></label>
              <input type="checkbox" 
                checked={typeof this.props.showFailed === 'string' && this.props.showFailed.toLowerCase() === 'true'} 
                onChange={this.checkboxChangeHandlerFactory('showFailed')}/>
              <label className="checkbox"><LanguageStringResolver string='transmissionStatusFilterPanel_Failed'/></label>
            </fieldset>
        );
    }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}


// Wrap the component to inject state into it
export default connect(mapStateToProps)(TransmissionStatusVisibilitySelector);
